<template>
  <div class="page-wrap">
    <div class="session-form-hold">
      <base-card>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          top
          color="primary"
        ></v-progress-linear>
        <v-card-text class="text-center" style="padding: 30px;">
          <v-avatar size="200" tile class="mb-4">
            <img
              src="@/assets/images/logos/boundless-logo-blue.png"
              alt=""
            />
          </v-avatar>
          <h6 class="text--disabled font-weight-medium mb-6">
            Sign in to your account
          </h6>
          <v-form @submit.prevent="formSubmit">
            <v-alert
              dense
              outlined
              type="error"
              v-if="error"
              class="mb-4 mt-6"
            >
              <small>{{ error }}</small>
            </v-alert>
            <v-text-field
              label="email"
              v-model="email"
              :rules="emailRules"
              required
            />

            <v-text-field
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show ? 'text' : 'password'"
              name="input-10-2"
              label="password"
              :rules="nameRules"
              v-model="ePassword"
              @click:append="show = !show"
            ></v-text-field>
            <!--<v-checkbox
              v-model="saveSession"
              label="Remember this computer"
            ></v-checkbox>-->
            <v-btn
              class="mb-4"
              block
              color="primary"
              dark
              type="submit"
              :dark="!loading"
              :disabled="loading"
            >
              <v-icon left>mdi-login</v-icon>
              Sign In
            </v-btn
            >
          </v-form>
        </v-card-text>
      </base-card>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Login',
  metaInfo: {
    title: 'Sign In'
  },
  data() {
    return {
      show: false,
      saveSession: true,
      checkbox2: false,
      email: '',
      ePassword: '',
      emailRules: [
        (v) => !!v || 'E-mail is required',
        (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid'
      ],
      nameRules: [
        (v) => !!v || 'Password is required',
      ]
    }
  },
  computed: {
    ...mapGetters(['loggedInUser', 'error', 'loading'])
  },
  methods: {
    ...mapActions([
      'login',
      'trackEvent',
    ]),
    async formSubmit() {
      const username = this.email.trim().toLowerCase();
      await this.login({ username, password: this.ePassword, saveSession: true });
      this.trackEvent({
        eventName: 'UserLoggedIn',
        eventDetails: {
          username,
        }
      });
    },
  },
  watch: {
    loggedInUser(val) {
      if (val && val.uid && val.uid.length > 0) {
        setTimeout(() => {
          this.$router.push('/');
        }, 500)
      }
    },
    error(val) {
      if (val != null) {
        // this.makeToast("warning", val.message);
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.page-wrap {
  background-color: #242939 !important;
  display: flex;
  align-items: center;
  padding: 40px 1rem;
  height: 100%;
  min-height: 100vh;
}

.session-form-hold {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
}
</style>
